module.exports = __webpack_public_path__ + "img/setupProducts.ca66e74d.png";